import React from "react";

const Payment = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66707 3.60457C6.58684 3.60457 6.52182 3.66959 6.52182 3.74982V5.41648C6.52182 5.7965 6.21375 6.10457 5.83373 6.10457C5.45371 6.10457 5.14565 5.7965 5.14565 5.41648V3.74982C5.14565 2.90956 5.82679 2.22839 6.66707 2.22839H17.5004C18.3407 2.22839 19.0218 2.90956 19.0218 3.74982V11.2498C19.0218 12.0901 18.3407 12.7712 17.5004 12.7712H16.6671C16.287 12.7712 15.979 12.4632 15.979 12.0831C15.979 11.7031 16.287 11.3951 16.6671 11.3951H17.5004C17.5806 11.3951 17.6456 11.33 17.6456 11.2498V3.74982C17.6456 3.66959 17.5806 3.60457 17.5004 3.60457H6.66707Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49983 8.60457C2.41961 8.60457 2.35459 8.6696 2.35459 8.74982V16.2498C2.35459 16.33 2.41961 16.3951 2.49983 16.3951H13.3332C13.4134 16.3951 13.4784 16.33 13.4784 16.2498V8.74982C13.4784 8.6696 13.4134 8.60457 13.3332 8.60457H2.49983ZM0.978409 8.74982C0.978409 7.90956 1.65957 7.22839 2.49983 7.22839H13.3332C14.1734 7.22839 14.8546 7.90956 14.8546 8.74982V16.2498C14.8546 17.0901 14.1734 17.7712 13.3332 17.7712H2.49983C1.65957 17.7712 0.978409 17.0901 0.978409 16.2498V8.74982Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.978409 11.6665C0.978409 11.2865 1.28648 10.9784 1.6665 10.9784H14.1665C14.5465 10.9784 14.8546 11.2865 14.8546 11.6665C14.8546 12.0465 14.5465 12.3546 14.1665 12.3546H1.6665C1.28648 12.3546 0.978409 12.0465 0.978409 11.6665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1665 8.89539C14.5465 8.89539 14.8546 9.20345 14.8546 9.58347V14.5835C14.8546 14.9635 14.5465 15.2716 14.1665 15.2716C13.7865 15.2716 13.4784 14.9635 13.4784 14.5835V9.58347C13.4784 9.20345 13.7865 8.89539 14.1665 8.89539Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.6665 8.89539C2.04652 8.89539 2.35459 9.20345 2.35459 9.58347V14.5835C2.35459 14.9635 2.04652 15.2716 1.6665 15.2716C1.28648 15.2716 0.978409 14.9635 0.978409 14.5835V9.58347C0.978409 9.20345 1.28648 8.89539 1.6665 8.89539Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.89565 14.1665C3.89565 13.7865 4.20371 13.4784 4.58373 13.4784H7.91707C8.29709 13.4784 8.60516 13.7865 8.60516 14.1665C8.60516 14.5465 8.29709 14.8546 7.91707 14.8546H4.58373C4.20371 14.8546 3.89565 14.5465 3.89565 14.1665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.72841 14.1665C9.72841 13.7865 10.0365 13.4784 10.4165 13.4784H11.2498C11.6299 13.4784 11.9379 13.7865 11.9379 14.1665C11.9379 14.5465 11.6299 14.8546 11.2498 14.8546H10.4165C10.0365 14.8546 9.72841 14.5465 9.72841 14.1665Z"
      fill="currentColor"
    />
  </svg>
);

export default React.memo(Payment);
